import axiosInstance from "../helpers/axiosInstance";

export const getTemplateApi = async () => {
    const url = `staff/templates`;
    const response = await axiosInstance.get(url);
    return response.data;
};

export const getOneTemplateApi = async (templateId) => {
    const url = `staff/templates${templateId}`;
    const response = await axiosInstance.get(url);
    return response.data;
};

export const getSettingsApi = async () => {
    const url = `public/settings`;
    const response = await axiosInstance.get(url);
    return response.data;
};
